import { render, staticRenderFns } from "./FormEditorItem.vue?vue&type=template&id=7973f398&scoped=true"
import script from "./FormEditorItem.vue?vue&type=script&lang=js"
export * from "./FormEditorItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973f398",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7973f398')) {
      api.createRecord('7973f398', component.options)
    } else {
      api.reload('7973f398', component.options)
    }
    module.hot.accept("./FormEditorItem.vue?vue&type=template&id=7973f398&scoped=true", function () {
      api.rerender('7973f398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/formItems/FormEditorItem.vue"
export default component.exports